import { useState, useEffect } from 'react'
import { supabase } from '../../api/supabase'

interface Branch {
  code: string
  name: string
  is_active: boolean
}

export default function Branches() {
  const [branches, setBranches] = useState<Branch[]>([])
  const [loading, setLoading] = useState(true)
  const [toggling, setToggling] = useState<string | null>(null)

  const fetchBranches = async () => {
    setLoading(true)
    const { data } = await supabase
      .from('branches')
      .select('*')
      .order('code')
    setBranches(data || [])
    setLoading(false)
  }

  useEffect(() => { fetchBranches() }, [])

  const toggleActive = async (code: string, current: boolean) => {
    setToggling(code)
    await supabase.from('branches').update({ is_active: !current }).eq('code', code)
    await fetchBranches()
    setToggling(null)
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Manage Branches</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          CY UK branch offices — BHX (Birmingham) and LHR (Slough)
        </p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-500">Loading...</div>
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow overflow-hidden max-w-xl">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 dark:bg-gray-700 border-b dark:border-gray-600">
              <tr>
                {['Code', 'Name', 'Status', 'Actions'].map(h => (
                  <th key={h} className="px-4 py-3 text-left font-semibold text-gray-600 dark:text-gray-300">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
              {branches.map(b => (
                <tr key={b.code} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                  <td className="px-4 py-3 font-mono font-bold text-gray-800 dark:text-gray-200">{b.code}</td>
                  <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{b.name}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                      b.is_active
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                        : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                    }`}>
                      {b.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => toggleActive(b.code, b.is_active)}
                      disabled={toggling === b.code}
                      className={`text-xs font-medium disabled:opacity-50 ${
                        b.is_active ? 'text-red-600 hover:underline' : 'text-green-600 hover:underline'
                      }`}
                    >
                      {toggling === b.code ? '...' : b.is_active ? 'Deactivate' : 'Activate'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
